import {ItemsListOptions} from './models/itemsListOptions';
import {ItemsListController} from './controllers/itemsListController';

import './filters/itemWrapperFilter';
import './styles/itemsList.scss';
import '../focus/focusDirective';
import '../infiniteScroll/infiniteScrollDirective';
import '../noResults/noResultsDirective';

export class ItemsListDirective implements angular.IDirective {
    restrict = 'E';
    controller = ItemsListController;
    controllerAs = 'vm';
    template = require('./templates/itemsList.html');
    replace = true;
    bindToController = {
        items: '=',
        itemIdProperty: '@',
        itemIconProperty: '@',
        itemIconTooltipProperty: '@',
        itemHeaderProperty: '@',
        itemMetadataProperties: '@',
        itemRightHeaderProperty: '@',
        itemRightHeaderNumberOfDecimalsProperty: '@',
        itemRightHeaderUomProperty: '@',
        isItemRightHeaderNumberProperty: '@',
        isLetterIcon: '@',
        selectedItem: '=',
        selectedItemChanged: '&',
        searchTerm: '=',
        infiniteScrolling: '&',
        scrollToTop: '=',
        isLoadingMore: '=',
        isLoading: '=',
        itemIcon: '@',
        groupingProperty: '@',
        isGlobalSearchAllowed: '=',
        isSearchAllRequestsButtonVisible: '=',
        isSearchAllRequestsButtonAllowedForUser: '='

    };
    scope = {};

    link = (scope, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, controller: ItemsListController): void => {

        if (!attrs['itemIdProperty'])
            console.error('Provide item-id-property on items-list directive for better performance.');

        controller.options = new ItemsListOptions(attrs);

        const mdListElement = element.children('md-list');
        controller.onGoToTop = () => {
            scope.$applyAsync(() => {
                if (mdListElement.length !== 0) {
                    mdListElement[0].scrollTop = 0;
                }
            });
        };
    };

    static factory(): angular.IDirectiveFactory {
        return () => new ItemsListDirective();
    }
}

angular.module('deliveryCreate.app').directive('itemsList', ItemsListDirective.factory());



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/directives/itemsList/itemsListDirective.ts
 **/